module.exports = __webpack_public_path__ + "img/ArchiveManagerLocal.8eea5346.svg";